import React, { useEffect, useState } from 'react'
import { ServerRequestProtected } from '../../utils/ServerDataRequest'
import NotificationHandler from '../../utils/NotificationHandler'
import Loader from '../shared/Loader/Loader'
import { enumUtil } from '../../utils/Enum'
import isNull from '../../utils/NullChecking'
function NpiRegistry(props) {
    let Registry_Modal = {
        OrganizationName: "",
        LastName: "",
        FirstName: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactPhoneNumber: "",
        PayToAddressLine1: "",
        PayToAddressLine2: "",
        PayToCity: "",
        PayToState: "",
        PayToZipCode: "",
        NPI: "",
        TaxID: "",
        ContactPersonName: "",
        TaxonomyCode: "",
        MedicareProviderType: "",
        FaxNumber: "",
        NPIType: "",
        EnumerationDate: "",
        Status: "",
    }
    const [isLoading, setIsLoading] = useState(false)
    const [RegistryData, setRegistryData] = useState({});
    const [CheckReg, setIsCheckReg] = useState(false);
    // const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const API_URL = enumUtil.controller.General
    let { isOpenRegistry, NpiNumber, onClosee, onCloseNpi } = { ...props }


    const NpiData = () => {
        setIsLoading(true)
        if (NpiNumber === "") {
            NotificationHandler('Please Enter Valid NPI', enumUtil.enumtoaster.error);
            setIsLoading(false)
        } else {
            ServerRequestProtected(API_URL + "/FindNpiDetails?Npi=" + NpiNumber, 'get', {
            }).then(response => {
                if (response.result_count > 0) {
                    Registry_Modal.LastName = response.results[0].enumeration_type === 'NPI-2' ? response.results[0].basic.authorized_official_last_name : response.results[0].basic.last_name
                    Registry_Modal.FirstName = response.results[0].enumeration_type === 'NPI-2' ? response.results[0].basic.authorized_official_first_name : response.results[0].basic.first_name
                    Registry_Modal.OrganizationName = response.results[0].enumeration_type === 'NPI-2' ? response.results[0].basic.organization_name : ''
                    Registry_Modal.ContactPersonName = Registry_Modal.FirstName + ' ' + Registry_Modal.LastName;
                    if (response.results[0].addresses.length > 0) {
                        if (response.results[0].addresses[0].address_purpose === 'LOCATION') {
                            Registry_Modal.AddressLine1 = !isNull(response.results[0].addresses[0].address_1) ? response.results[0].addresses[0].address_1 : '';
                            Registry_Modal.AddressLine2 = !isNull(response.results[0].addresses[0].address_2) ? response.results[0].addresses[0].address_2 : '';
                            Registry_Modal.City = !isNull(response.results[0].addresses[0].city) ? response.results[0].addresses[0].city : '';
                            Registry_Modal.State = !isNull(response.results[0].addresses[0].state) ? response.results[0].addresses[0].state : '';
                            Registry_Modal.ZipCode = !isNull(response.results[0].addresses[0].postal_code) ? response.results[0].addresses[0].postal_code : '';
                        } else if (response.results[0].addresses[0].address_purpose === 'MAILING') {
                            Registry_Modal.PayToAddressLine1 = !isNull(response.results[0].addresses[0].address_1) ? response.results[0].addresses[0].address_1 : '';
                            Registry_Modal.PayToAddressLine2 = !isNull(response.results[0].addresses[0].address_2) ? response.results[0].addresses[0].address_2 : '';
                            Registry_Modal.PayToCity = !isNull(response.results[0].addresses[0].city) ? response.results[0].addresses[0].city : '';
                            Registry_Modal.PayToState = !isNull(response.results[0].addresses[0].state) ? response.results[0].addresses[0].state : '';
                            Registry_Modal.PayToZipCode = !isNull(response.results[0].addresses[0].postal_code) ? response.results[0].addresses[0].postal_code : '';
                        }
                        Registry_Modal.ContactPhoneNumber = response.results[0].enumeration_type === 'NPI-2' ? response.results[0].basic.authorized_official_telephone_number : response.results[0].addresses[0].telephone_number
                        if (response.results[0].addresses[1].address_purpose === 'MAILING') {
                            Registry_Modal.PayToAddressLine1 = !isNull(response.results[0].addresses[1].address_1) ? response.results[0].addresses[1].address_1 : '';
                            Registry_Modal.PayToAddressLine2 = !isNull(response.results[0].addresses[1].address_2) ? response.results[0].addresses[1].address_2 : '';
                            Registry_Modal.PayToCity = !isNull(response.results[0].addresses[1].city) ? response.results[0].addresses[1].city : '';
                            Registry_Modal.PayToState = !isNull(response.results[0].addresses[1].state) ? response.results[0].addresses[1].state : '';
                            Registry_Modal.PayToZipCode = !isNull(response.results[0].addresses[1].postal_code) ? response.results[0].addresses[1].postal_code : '';
                        } else if (response.results[0].addresses[1].address_purpose === 'LOCATION') {
                            Registry_Modal.AddressLine1 = !isNull(response.results[0].addresses[1].address_1) ? response.results[0].addresses[1].address_1 : '';
                            Registry_Modal.AddressLine2 = !isNull(response.results[0].addresses[1].address_2) ? response.results[0].addresses[1].address_2 : '';
                            Registry_Modal.City = !isNull(response.results[0].addresses[1].city) ? response.results[0].addresses[1].city : '';
                            Registry_Modal.State = !isNull(response.results[0].addresses[1].state) ? response.results[0].addresses[1].state : '';
                            Registry_Modal.ZipCode = !isNull(response.results[0].addresses[1].postal_code) ? response.results[0].addresses[1].postal_code : '';
                        }
                        Registry_Modal.FaxNumber = !isNull(response.results[0].addresses[0].fax_number) ? response.results[0].addresses[0].fax_number : '';
                        Registry_Modal.NPIType = !isNull(response.results[0].enumeration_type) ? response.results[0].enumeration_type : '';
                        Registry_Modal.EnumerationDate = !isNull(response.results[0].basic.enumeration_date) ? response.results[0].basic.enumeration_date : '';
                        Registry_Modal.Status = !isNull(response.results[0].basic.status) ? response.results[0].basic.status : '';
                    }
                    if (response.results[0].taxonomies.length > 0) {
                        Registry_Modal.TaxonomyCode = !isNull(response.results[0].taxonomies[0].code) ? response.results[0].taxonomies[0].code : '';
                        Registry_Modal.MedicareProviderType = !isNull(response.results[0].taxonomies[0].desc) ? response.results[0].taxonomies[0].desc : '';
                    }
                    Registry_Modal.NPI = NpiNumber;
                    setRegistryData(Registry_Modal);
                    setIsLoading(false)
                } else {
                    NotificationHandler('Please Enter Valid NPI', enumUtil.enumtoaster.error)
                    setIsLoading(false)
                    handleClose()
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                handleClose()

            })
        }
    }

    useEffect(() => {
        NpiData();
    }, [])
    const handleRegistry = () => {
        // setIsCheckReg(true);
        onClosee(RegistryData)
    }
    const handleClose = () => {
        onCloseNpi()
    }
    // if(CheckReg){
    //     onClosee(RegistryData)
    // }

    return (
        <React.Fragment>
            <div className={isOpenRegistry ? props.ClassName : 'npi-panel '}
                style={{ "z-index": "3000" }}>
                <div className='npi-panel__header'>
                    <p className="heading">NPI Details</p>
                    <div className='d-flex'>
                        <div className={isLoading ? 'loader' : ''}></div>
                        <button className="btn-icon-transparent" onClick={handleClose}><i className="icon-Icon-metro-cross"></i></button>
                    </div>
                </div>
                <div className='row npi-panel__body npi_detail'>
                    <div className="col-md-5 pe-1">
                        <div className="list-info">
                            <div className="item">
                                <div className="heading">Name</div>
                                <div className="value">{RegistryData.NPIType === 'NPI-2' ? RegistryData.OrganizationName : RegistryData.LastName + ' ' + RegistryData.FirstName}</div>
                            </div>
                            <div className="item">
                                <div className="heading">NPI</div>
                                <div className="value">{RegistryData.NPI}</div>
                            </div>
                            <div className="item">
                                <div className="heading">Enumeration Date</div>
                                <div className="value">{RegistryData.EnumerationDate}</div>
                            </div>
                            <div className="item">
                                <div className="heading">NPI Type</div>
                                <div className="value">{RegistryData.NPIType === 'NPI-1' ? 'Individual' : 'Organization'}</div>
                            </div>
                            <div className="item">
                                <div className="heading">Status</div>
                                <div className="value">{RegistryData.Status === 'A' ? 'Active' : 'InActive'}</div>
                            </div>
                            <div className="item">
                                <div className="heading col-md-6">Taxonomy Code</div>
                                <div className="value">{RegistryData.TaxonomyCode}</div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-6 ps-1 pe-1 right_npi pb-0">
                        <div className="list-info">
                            <div className="item">
                                <div className="heading col-md-6">Primary Address</div>
                                <div className="value">{!isNull(RegistryData.AddressLine1) ? RegistryData.AddressLine1 + ' ' + RegistryData.AddressLine2 + ',' + RegistryData.City + ' ' + RegistryData.State + ', ' + RegistryData.ZipCode : ''}</div>
                            </div>
                            <div className="item">
                                <div className="heading col-md-6">Mailing Address</div>
                                <div className="value">{!isNull(RegistryData.PayToAddressLine1) ? RegistryData.PayToAddressLine1 + ' ' + RegistryData.PayToAddressLine2 + ' ' + RegistryData.PayToCity + ' ' + RegistryData.PayToState : ''}, {RegistryData.PayToZipCode}</div>
                            </div>
                            <div className="item">
                                <div className="heading col-md-6">Contact Info</div>
                                <div className="value">Name: {RegistryData.ContactPersonName}  <br></br> Phone #:  {RegistryData.ContactPhoneNumber}  <br></br> Fax #: {RegistryData.FaxNumber}<br></br></div>
                                {/* <div className="value"></div>
                                <div className="value"></div> */}

                            </div>
                        </div>
                    </div>
                </div>
                <div className='text-end npi-panel__footer'>
                    <button className='btn btn-orange btn-sm' onClick={handleRegistry}>Apply</button>
                </div>

                {/* <div className="col-md-12" style={{textAlign: 'right'}}>
                    <button className="btn btn-primary " data-dismiss="modal"  onClick={handleClose}>Cancel</button>
                    <button className="btn btn-primary" style={{margin: '.5rem'}} >Apply</button>
                </div> */}
            </div>
        </React.Fragment>

    )
}

export default NpiRegistry